import React, { useState, useCallback } from 'react';

import Container from "react-bootstrap/Container";
import Button from "react-bootstrap/Button";
import Spinner from "react-bootstrap/Spinner";
import Alert from "react-bootstrap/Alert";

import QuizApi from '../QuizApi';

const ERROR_MESSAGES = {
	email_not_verified: "Du måste verifiera din e-postadress innan du kan logga in. Kolla din inkorg — om mejlet inte kom fram kan du registrera dig igen med samma adress för att få en ny länk.",
};
const DEFAULT_ERROR_MESSAGE = "Fel användarnamn eller lösenord.";

export default function UserLoginPage(props) {

	const { onAuthSuccess } = props;

	const [username, setUsername] = useState("");
	const [password, setPassword] = useState("");
	const [loading, setLoading] = useState(false);
	const [errorMsg, setErrorMsg] = useState("");

  const onSubmit = useCallback(evt => {

    evt.preventDefault();

		const login = async () => {

			setLoading(true);
			setErrorMsg("");

			const result = await QuizApi.userLogin(username, password);

			setLoading(false);

			if (result && result.success && result.response) {
				onAuthSuccess(result.response);
			} else {
				setErrorMsg(ERROR_MESSAGES[result && result.error] || DEFAULT_ERROR_MESSAGE);
			}
		};

		login();

  }, [username, password, onAuthSuccess])

	return (
		<div id="userLoginPage" className="bg-purple h-100">
			<div className="d-flex justify-content-center align-items-center h-100">
				<div className="text-center">

					{loading && (
						<Container>
							<div className="d-flex justify-content-center align-items-center h-100">
								<Spinner animation="border" />
							</div>
						</Container>
					)}

					{!loading &&
						<form onSubmit={onSubmit}>

							{errorMsg && <Alert variant="danger" style={{ maxWidth: "360px" }}>{errorMsg}</Alert>}

							<h5>Användarnamn</h5>
							<input type="text" 
								className="form-control mb-2" 
								value={username}
								onChange={ev => setUsername(ev.target.value) } 
							/>

							<h5>Lösenord</h5>
							<input type="password" 
								className="form-control mb-2" 
								value={password}
								onChange={ev => setPassword(ev.target.value) } 
							/>

							<Button type="submit" className="mt-3" variant="quizPrimary">
								Logga in
							</Button>

						</form>
					}

				</div>
			</div>
		</div>
	);
};